import { ReactElement } from 'react';

import { formatEntryAmount } from '~/ui/pages/Clients/reusable/CommunityEngagement/helpers/formatAmount';

import styles from '~/ui/pages/Clients/reusable/CommunityEngagement/CommunityEngagement.module.scss';

interface IEntryAmountProps {
  minutesWorked: number | null;
  currencyEarned: number | null;
}

const EntryAmount = ({ minutesWorked, currencyEarned }: IEntryAmountProps): ReactElement => (
  <div className={styles.rowTitle}>{formatEntryAmount(minutesWorked, currencyEarned)}</div>
);

export default EntryAmount;
